import { observer } from 'mobx-react';
import ReadOnlyTruncatedRecipientWell from 'owa-readonly-recipient-well/lib/components/ReadOnlyTruncatedRecipientWell';
import mergeReadWriteRecipientWellIntoReadOnly from '../utils/mergeReadWriteRecipientWellIntoReadOnly';
import * as React from 'react';
var styles = require('./CompactRecipientWell.scss');
var classNames = require('classnames');
var CompactRecipientWell = observer(function (props) {
    var allRecipients = [];
    mergeReadWriteRecipientWellIntoReadOnly(props.toRecipientWell, allRecipients);
    mergeReadWriteRecipientWellIntoReadOnly(props.ccRecipientWell, allRecipients);
    return (React.createElement("div", { className: classNames(styles.compactRecipientRow, props.className), onFocus: props.onSwitchToReadWriteWell, tabIndex: 0 },
        React.createElement(ReadOnlyTruncatedRecipientWell, { recipientType: props.recipientType, recipients: allRecipients, totalRecipientCount: allRecipients.length, onToggleIsTruncated: props.onSwitchToReadWriteWell, disableHover: true })));
});
export default CompactRecipientWell;
//# sourceMappingURL=CompactRecipientWell.js.map